var map = {
	"./athletes-ic.png": 927,
	"./balanced-ic.png": 928,
	"./keto-ic.png": 929,
	"./vegan-ic.png": 930,
	"./vegetarian-ic.png": 931,
	"./weight-loss-ic.png": 932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 476;